import Select from "react-select";
import AsyncSelect from "react-select/async";
import React from "react";
import FormLabel from "../form/FormLabel";
import AsyncCreatableSelect from "react-select/async-creatable";

const LabeledSelect = ({
                         options = [], label, value, onChange, emptyMsg, className,
                         isRequired,
                         loading, loadOptions, ...props
                       }) => {

  return <div className="w-full mb-4">
    {
      label ?
        (
          <div className={className}>
            <FormLabel label={label} isRequired={isRequired}/>
            <SelectType options={options} onChange={onChange} isLoading={loading} loadOptions={loadOptions}
                        value={value} noOptionsMessage={() => emptyMsg} {...props}/>
          </div>
        ) : (
          <SelectType options={options} onChange={onChange} isLoading={loading} loadOptions={loadOptions}
                      className={className}
                      value={value} noOptionsMessage={() => emptyMsg} {...props}/>
        )

    }
  </div>;

  function SelectType({loadOptions, options, maxHeight, creatable = false, ...props}) {
    return (creatable && loadOptions) ? <AsyncCreatableSelect loadOptions={loadOptions}

                                                              styles={{
                                                                menuPortal: (provided, state) => ({
                                                                  ...provided,
                                                                  zIndex: 30
                                                                }),
                                                                menuList: (base) => ({
                                                                  ...base,
                                                                  ...(maxHeight !== undefined && {maxHeight: maxHeight})

                                                                })
                                                              }}

                                                              menuPortalTarget={document.querySelector("body")} {...props}/>
      : loadOptions ?
        <AsyncSelect loadOptions={loadOptions} {...props}
                     styles={{
                       menuPortal: (provided, state) => ({
                         ...provided,
                         zIndex: 30
                       }),
                       menuList: (base) => ({
                         ...base,
                         ...(maxHeight !== undefined && {maxHeight: maxHeight})

                       })
                     }}
                     menuPortalTarget={document.querySelector("body")}/>
        :


        <Select options={options} {...props}
                styles={{
                  menuPortal: (provided, state) => ({
                    ...provided,
                    zIndex: 30
                  }),
                  menuList: (base) => ({
                    ...base,
                    ...(maxHeight !== undefined && {maxHeight: maxHeight})

                  })
                }}

                menuPortalTarget={document.querySelector("body")
                }
                onKeyDown={(e) => {
                  // console.log(e.key === ' ');
                  // if (e.keyCode === 32) {
                  //   e.preventDefault();
                  // }
                }}/>;
  }
};

export default React.memo(LabeledSelect);
